import React from 'react';
const ChurchContext = React.createContext();
export default ChurchContext;